import React from 'react';

import { EditorCheckbox } from 'components/Editors/components/EditorCheckbox';

import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import { CSSItem, CSSItemLabel, CSSItemLabelWithEllipsis } from '../JRCWidgetDatasourceTableEditor.styles';

export const WidgetDatasourceModelViewColumn = ({
    label,
    isVisible,
    isActive,
    onChange,
}: {
    label: string;
    isVisible?: boolean;
    isActive?: boolean;
    onChange: (isVisible: boolean) => void;
}) => {
    return (
        <CSSItem>
            <JRCIcon name="icon-reorder" color={'grey1'} size={14} />
            <EditorCheckbox
                initialValue={isVisible}
                isDisabled={!isActive}
                onChange={(value) => {
                    if (isVisible !== value) {
                        onChange(value);
                    }
                }}
            />
            <CSSItemLabel>
                <CSSItemLabelWithEllipsis>{label}</CSSItemLabelWithEllipsis>
            </CSSItemLabel>
        </CSSItem>
    );
};
